import { render, staticRenderFns } from "./Roadblock.vue?vue&type=template&id=0590be50&scoped=true&"
import script from "./Roadblock.vue?vue&type=script&lang=js&"
export * from "./Roadblock.vue?vue&type=script&lang=js&"
import style0 from "./Roadblock.vue?vue&type=style&index=0&id=0590be50&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0590be50",
  null
  
)

export default component.exports